import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StatusCustomDropdown from "../common/StatusCustomDropdown";
import config from "../../envconfig";
import ConfirmationPopup from "../common/ConfirmationPopup ";
import Icon5 from "../../assest/images/Icon5.png";
import Icon4 from "../../assest/images/Icon4.png";
import Icon3 from "../../assest/images/Icon3.png";
import { UserContext } from "../common/UserContext";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function LGCMEdit() {
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
  } = useContext(UserContext);
  const { LGCM_ID } = useParams();
  const [loading, setLoading] = useState(false);
  const isProcessingRef = useRef(false);
  const [LogisticName, setLogisticName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [addClicked, setAddClicked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [originalEditData, setOriginalEditData] = useState(null);
  const [showUpdateAsterisk, setShowUpdateAsterisk] = useState(false);
  const [isToastActive, setIsToastActive] = useState(false);
  const [touched, setTouched] = useState({
    LGCVM_VehicleName: false,
    LGCVM_VehicleNumber: false,
  });
  const [updateAttempted, setUpdateAttempted] = useState(false);

  // Phone input country code support
  const allowedCountries = ["in", "af", "dz", "au", "at", "be", "us"];
  const [phoneNumberCountry, setPhoneNumberCountry] = useState("91");
  const [resetCounter, setResetCounter] = useState(0);
  const prevCountryRef = useRef(phoneNumberCountry || "91");
  const isEditLoadingRef = useRef(false);

  const phoneNumberToCountryCode = (dialCode) => {
    dialCode = String(dialCode);
    switch (dialCode) {
      case "91":
        return "in";
      case "1":
        return "us";
      case "93":
        return "af";
      case "213":
        return "dz";
      case "61":
        return "au";
      case "43":
        return "at";
      case "32":
        return "be";
      default:
        return undefined;
    }
  };

  const phoneLengthMapping = {
    91: 10, // India
    93: 9, // Afghanistan
    213: 9, // Algeria
    61: 9, // Australia
    43: 10, // Austria
    32: 9, // Belgium
    1: 10, // USA/Canada
  };

  // Helper function to clean phone number (remove + and spaces)
  const cleanPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";
    return String(phoneNumber).replace(/[\s+\-()]/g, "");
  };

  // Helper function to format phone number for display
  // Format: +XX XXXXXXXXXX (country code + space + digits)
  const formatPhoneNumberDisplay = (phoneNumber) => {
    if (!phoneNumber) return "-";

    // Clean the number first
    const cleanedNumber = cleanPhoneNumber(phoneNumber);

    // Sort country codes by length (longest first) to match correctly
    const sortedCodes = Object.keys(phoneLengthMapping).sort(
      (a, b) => b.length - a.length,
    );

    // Check which country code this number has
    for (const code of sortedCodes) {
      if (cleanedNumber.startsWith(code)) {
        const localNumber = cleanedNumber.slice(code.length);
        // Simple format: +CountryCode LocalNumber
        return `+${code} ${localNumber}`;
      }
    }

    // If no country code found, return as-is
    return phoneNumber;
  };

  const [formdata, setFormdata] = useState({
    LGCM_Name: "",
    LGCVM_VehicleNumber: "",
    LGCVM_VehicleName: "", // ✅ ADD
    LGCVM_Dimension: "", // ✅ ADD
    LGCVM_DriverName: "", // ✅ ADD
    LGCVM_DriverNumber: "", // ✅ ADD
    LGCM_Status: 1,
    LGCM_CompanyID: UM_CompanyID,
    LGCM_CompanyGrpID: UM_CompanyGrpID,
    LGCM_ModifiedBy: UM_UserId,
    LGCM_SCPID: selectedScpId,
  });

  const [message, setMessage] = useState("");
  const [validationError, setValidationError] = useState({
    LGCM_Name: "",
    LGCVM_VehicleNumber: "",
    LGCVM_VehicleName: "",
    LGCVM_Dimension: "",
    LGCVM_DriverName: "",
    LGCVM_DriverNumber: "",
  });

  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [vehicleNumbers, setVehicleNumbers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [SuspendMessage, setSuspendMessage] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [suspendIndex, setSuspendIndex] = useState(null);
  const hasActiveVehicle = vehicleDetails.some((v) => v.LGCVM_Status !== 3);
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
  ]);

  const validateField = (name, rawValue) => {
    let error = "";
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;

    switch (name) {
      case "LGCVM_VehicleName":
        if (!value) {
          // optional / handled elsewhere
        } else if (
          !/^[a-zA-Z0-9]$/.test(value[0]) ||
          !/^[a-zA-Z0-9]$/.test(value[value.length - 1])
        ) {
          error = "First and last character must be alphanumeric";
        } else if (!/^[a-zA-Z0-9-_ ]+$/.test(value)) {
          error = "Please use only special characters like -,_ and space";
        } else if (/[-_ ]{2,}/.test(value)) {
          error = "Consecutive special characters are not allowed";
        } else if (value.length > 45) {
          error = "Maximum length is 45 characters";
        }
        break;

      case "LGCVM_VehicleNumber":
        if (!value) {
          // handled on ADD click
        } else if (!/^[A-Z]/.test(value)) {
          error = "First character must be an alphabet";
        } else if (!/\d/.test(value)) {
          error = "At least one digit is required";
        } else if (!/^[A-Z0-9\s-]+$/.test(value)) {
          error = "Only alphanumeric, space and - allowed";
        } else if (!/^[A-Z0-9]$/.test(value[value.length - 1])) {
          error = "Last character must be alphanumeric";
        } else if (!/^([A-Z0-9]+[-\s]?[A-Z0-9]+)+$/.test(value)) {
          error = "Invalid format. Example: GJ-13-BD-3024";
        } else if (value.length > 45) {
          error = "Maximum length is 45 characters";
        }
        break;

      case "LGCVM_Dimension":
        if (value) {
          if (!/^[0-9]+$/.test(value)) {
            error = "Only positive numbers allowed";
          } else if (value.length !== 6) {
            // error = "Exactly 6 digits required";
          }
        }
        break;

      case "LGCVM_DriverName":
        if (value) {
          if (!/^[a-zA-Z ]+$/.test(value)) {
            error = "Only alphabets and spaces allowed";
          } else if (value.length > 45) {
            error = "Maximum length is 45 characters";
          } else if (/  +/.test(value)) {
            error = "Consecutive special characters are not allowed";
          }
        }
        break;

      case "LGCVM_DriverNumber":
        // Phone validation - check if complete number of digits entered
        if (value) {
          const digits = value.replace(/\D/g, "");

          // Find which country code this number has
          let countryCode = null;
          let expectedLength = 0;

          for (const [code, length] of Object.entries(phoneLengthMapping)) {
            if (digits.startsWith(code)) {
              countryCode = code;
              expectedLength = parseInt(code.length) + length;
              break;
            }
          }

          // If we found a country code, validate the local number
          if (countryCode) {
            const localNumber = digits.slice(countryCode.length);

            // Check if starts with 0
            if (localNumber.startsWith("0")) {
              error = "Phone number cannot start with 0";
            }
            // Check if incomplete
            else if (
              localNumber.length > 0 &&
              digits.length !== expectedLength
            ) {
              const requiredDigits = phoneLengthMapping[countryCode];
              error = `Please enter complete ${requiredDigits} digit phone number`;
            }
          }
        }
        break;

      default:
        break;
    }

    return error;
  };

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Logistic Party Master:",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  const logAudit = async (
    module,
    message,
    oldValue = "",
    newValue = "",
    isError = false,
    transactionDetails = [],
  ) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 7,
      AUTR_SCPID: selectedScpId || null,
      AUTR_CompanyGrpId: UM_CompanyGrpID || null,
      AUTR_CompanyID: UM_CompanyID || null,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0, // Flag to determine if transaction details should be inserted
      transactionDetails, // Array of transaction details to be inserted into audittransaction
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDeleteIndex(null);
  };

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${config.API_URL}/logistic_company_master/fetch/${LGCM_ID}`,
      );
      if (!response.ok) throw new Error("Failed to fetch data");

      const data = await response.json();

      const filteredData = data.filter((v) => v.LGCVM_Status !== 3);

      setFormdata({
        LGCM_Name: filteredData[0]?.LGCM_Name || "",
        LGCM_Status: filteredData[0]?.LGCM_Status || 1,
        LGCVM_VehicleNumber: "",
        LGCVM_VehicleName: "",
        LGCVM_Dimension: "",
        LGCVM_DriverName: "",
        LGCVM_DriverNumber: "",
      });

      setVehicleDetails(filteredData); // ✅ now includes name + dimension
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setMessage("Error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [LGCM_ID, LogisticName]);

  const handleInput = (e, countryData) => {
    // Handle PhoneInput onChange (value, countryData)
    if (typeof e === "string" && countryData) {
      const value = e;
      const newDialCode = countryData?.dialCode;
      const prevDialCode = prevCountryRef.current;
      const isCountryChange = newDialCode !== prevDialCode;
      const maxLength = phoneLengthMapping[newDialCode] || 10;

      let digits = value.replace(/\D/g, "");

      // Extract local number (remove dial code)
      let local = "";
      if (digits.startsWith(newDialCode)) {
        local = digits.slice(newDialCode.length);
      } else {
        local = digits;
      }

      // STRICT: Block input if trying to enter more than maxLength digits
      if (local.length > maxLength) {
        // Reject this input - don't update state
        return;
      }

      // Validation logic - only check for leading zero
      if (local.length === 0) {
        setValidationError((prev) => ({ ...prev, LGCVM_DriverNumber: "" }));
      } else if (local.startsWith("0")) {
        setValidationError((prev) => ({
          ...prev,
          LGCVM_DriverNumber: "Phone number cannot start with 0",
        }));
      } else {
        setValidationError((prev) => ({ ...prev, LGCVM_DriverNumber: "" }));
      }

      // On country change → reset local number
      const finalValue = isCountryChange ? newDialCode : newDialCode + local;

      setFormdata((prev) => ({
        ...prev,
        LGCVM_DriverNumber: finalValue,
      }));

      setPhoneNumberCountry(newDialCode);
      prevCountryRef.current = newDialCode;

      return;
    }

    // Handle regular input onChange (e.target)
    const { name, value } = e.target;
    let finalValue = value;

    // Auto-remove leading spaces and prevent consecutive spaces
    if (["LGCM_Name", "LGCVM_VehicleName", "LGCVM_Dimension", "LGCVM_DriverName", "LGCVM_VehicleNumber"].includes(name)) {
      finalValue = value.trimStart().replace(/\s{2,}/g, " ");
    }

    // 🔥 Uppercase Vehicle Number
    if (name === "LGCVM_VehicleNumber") {
      finalValue = finalValue.toUpperCase();
    }

    // 🔒 Dimension: only numbers, exactly 6 digits
    if (name === "LGCVM_Dimension") {
      // Remove all non-digit characters
      const digits = finalValue.replace(/\D/g, "");
      // Block input if more than 6 digits
      if (digits.length > 6) {
        return;
      }
      finalValue = digits;
    }

    setFormdata((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    const error = validateField(name, finalValue);
    setValidationError((prev) => ({ ...prev, [name]: error }));

    // Mark field as touched when user types in it
    if (name === "LGCVM_VehicleName" || name === "LGCVM_VehicleNumber") {
      setTouched((prev) => ({ ...prev, [name]: true }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (value && typeof value === 'string') {
      const trimmedValue = value.trim();
      if (trimmedValue !== value) {
        setFormdata((prev) => ({
          ...prev,
          [name]: trimmedValue,
        }));
        const error = validateField(name, trimmedValue);
        setValidationError((prev) => ({ ...prev, [name]: error }));
      }
    }
  };

  const handleAddVehicleNumber = () => {
    if (isEditing) {
      if (!toast.isActive("edit-in-progress")) {
        setIsToastActive(true);
        toast.error(
          "Please save or cancel the current edit before adding a new vehicle.",
          {
            toastId: "edit-in-progress",
            onOpen: () => setIsToastActive(true),
            onClose: () => setIsToastActive(false),
          },
        );
      }
      return;
    }

    setAddClicked(true); // 🔴 TRIGGER * ONLY ON ADD CLICK

    // Check for empty required fields - just return without adding error messages
    if (!formdata.LGCVM_VehicleNumber || !formdata.LGCVM_VehicleName) {
      return;
    }

    // Run validation explicitly for driver number to catch incomplete numbers
    const driverNumberError = validateField(
      "LGCVM_DriverNumber",
      formdata.LGCVM_DriverNumber,
    );
    if (driverNumberError) {
      setValidationError((prev) => ({
        ...prev,
        LGCVM_DriverNumber: driverNumberError,
      }));
    }

    // block add if has validation errors
    if (
      validationError.LGCVM_VehicleName ||
      validationError.LGCVM_VehicleNumber ||
      validationError.LGCVM_Dimension ||
      validationError.LGCVM_DriverName ||
      validationError.LGCVM_DriverNumber ||
      driverNumberError
    ) {
      return;
    }

    const isDuplicate = vehicleDetails.some(
      (v) => v.LGCVM_VehicleNumber === formdata.LGCVM_VehicleNumber,
    );

    if (isDuplicate) {
      if (!toast.isActive("vehicle-duplicate")) {
        setIsToastActive(true);
        toast.error(
          `Vehicle Number : ${formdata.LGCVM_VehicleNumber} already exists.`,
          {
            toastId: "vehicle-duplicate",
            onOpen: () => setIsToastActive(true),
            onClose: () => setIsToastActive(false),
          },
        );
      }
      return;
    }

    // Check if driver number contains only country code (no local digits)
    let finalDriverNumber = formdata.LGCVM_DriverNumber || null;
    if (finalDriverNumber) {
      const cleanedNumber = finalDriverNumber.replace(/\D/g, "");
      // Check if it's only a country code (no additional digits)
      const isOnlyCountryCode = Object.keys(phoneLengthMapping).some(
        (code) => cleanedNumber === code,
      );
      if (isOnlyCountryCode) {
        finalDriverNumber = null;
      }
    }

    setVehicleDetails((prev) => [
      ...prev,
      {
        LGCVM_VehicleNumber: formdata.LGCVM_VehicleNumber,
        LGCVM_VehicleName: formdata.LGCVM_VehicleName,
        LGCVM_Dimension: formdata.LGCVM_Dimension || null,
        LGCVM_DriverName: formdata.LGCVM_DriverName || null,
        LGCVM_DriverNumber: finalDriverNumber,
        LGCVM_Status: 1,
        isNew: true,
      },
    ]);

    // reset fields
    setFormdata((prev) => ({
      ...prev,
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    }));

    // Clear validation errors
    setValidationError({
      LGCM_Name: "",
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    });

    // Reset phone number state
    setPhoneNumberCountry("91");
    prevCountryRef.current = "91";
    setResetCounter((prev) => prev + 1);

    // Reset touched state for next add
    setTouched({
      LGCVM_VehicleName: false,
      LGCVM_VehicleNumber: false,
    });

    setAddClicked(false); // ✅ reset for next add
  };

  const handleEdit = async (index) => {
    const vehicle = vehicleDetails[index];

    // Check if this is a newly added vehicle (not saved to DB yet)
    if (vehicle.isNew) {
      // Allow editing without checking shipment usage
      setIsEditing(true);
      setEditingIndex(index);
      setOriginalEditData({ ...vehicle });

      // Clear validation errors from previous add attempt
      setValidationError({
        LGCM_Name: "",
        LGCVM_VehicleNumber: "",
        LGCVM_VehicleName: "",
        LGCVM_Dimension: "",
        LGCVM_DriverName: "",
        LGCVM_DriverNumber: "",
      });

      // Reset add click flag
      setAddClicked(false);

      // Reset touched state so asterisks can appear for empty fields
      setTouched({
        LGCVM_VehicleName: false,
        LGCVM_VehicleNumber: false,
      });

      // Reset update attempted flag
      setUpdateAttempted(false);

      // Extract and format driver number with country code
      const rawDriverNumber = vehicle.LGCVM_DriverNumber || "";
      const cleanedDriverNumber = cleanPhoneNumber(rawDriverNumber);
      let countryCode = "91";
      let formattedDriverNumber = "";

      if (cleanedDriverNumber) {
        // Sort country codes by length (longest first) to match correctly
        const sortedCodes = Object.keys(phoneLengthMapping).sort(
          (a, b) => b.length - a.length,
        );

        // Try to match known country codes at the start
        let foundCode = false;
        for (const code of sortedCodes) {
          if (cleanedDriverNumber.startsWith(code)) {
            countryCode = code;
            formattedDriverNumber = cleanedDriverNumber; // Use cleaned number
            foundCode = true;
            break;
          }
        }

        // If no country code found, prepend the default country code
        if (!foundCode) {
          formattedDriverNumber = countryCode + cleanedDriverNumber;
        }
      }

      // Set flag BEFORE any state changes to prevent onCountryChange firing
      isEditLoadingRef.current = true;

      setPhoneNumberCountry(countryCode);
      prevCountryRef.current = countryCode;
      setResetCounter((prev) => prev + 1);

      setFormdata((prev) => ({
        ...prev,
        LGCVM_VehicleNumber: vehicle.LGCVM_VehicleNumber,
        LGCVM_VehicleName: vehicle.LGCVM_VehicleName,
        LGCVM_Dimension: vehicle.LGCVM_Dimension || "",
        LGCVM_DriverName: vehicle.LGCVM_DriverName || "",
        LGCVM_DriverNumber: formattedDriverNumber,
      }));

      // Reset flag after component fully updates
      setTimeout(() => {
        isEditLoadingRef.current = false;
      }, 300);

      // toast.info(`Editing Vehicle: ${vehicle.LGCVM_VehicleNumber}`);
      return;
    }

    // For existing vehicles, check if used in shipments
    try {
      const response = await fetch(
        `${config.API_URL}/logistic_company_master/vehiclestatus/${vehicle.LGCVM_ID}`,
      );
      const data = await response.json();

      if (data.count > 0) {
        if (!toast.isActive("vehicle-in-use")) {
          setIsToastActive(true);
          toast.error(
            `Vehicle: ${vehicle.LGCVM_VehicleNumber} cannot be edited because it is used in ${data.count} shipment(s).`,
            {
              toastId: "vehicle-in-use",
              onOpen: () => setIsToastActive(true),
              onClose: () => setIsToastActive(false),
            },
          );
        }
        return;
      }

      // Allow editing if not used in shipments
      setIsEditing(true);
      setEditingIndex(index);
      setOriginalEditData({ ...vehicle });

      // Clear validation errors from previous add attempt
      setValidationError({
        LGCM_Name: "",
        LGCVM_VehicleNumber: "",
        LGCVM_VehicleName: "",
        LGCVM_Dimension: "",
        LGCVM_DriverName: "",
        LGCVM_DriverNumber: "",
      });

      // Reset add click flag
      setAddClicked(false);

      // Reset touched state so asterisks can appear for empty fields
      setTouched({
        LGCVM_VehicleName: false,
        LGCVM_VehicleNumber: false,
      });

      // Reset update attempted flag
      setUpdateAttempted(false);

      // Extract and format driver number with country code
      const rawDriverNumber = vehicle.LGCVM_DriverNumber || "";
      const cleanedDriverNumber = cleanPhoneNumber(rawDriverNumber);
      let countryCode = "91";
      let formattedDriverNumber = "";

      if (cleanedDriverNumber) {
        // Sort country codes by length (longest first) to match correctly
        const sortedCodes = Object.keys(phoneLengthMapping).sort(
          (a, b) => b.length - a.length,
        );

        // Try to match known country codes at the start
        let foundCode = false;
        for (const code of sortedCodes) {
          if (cleanedDriverNumber.startsWith(code)) {
            countryCode = code;
            formattedDriverNumber = cleanedDriverNumber; // Use cleaned number
            foundCode = true;
            break;
          }
        }

        // If no country code found, prepend the default country code
        if (!foundCode) {
          formattedDriverNumber = countryCode + cleanedDriverNumber;
        }
      }

      // Set flag BEFORE any state changes to prevent onCountryChange firing
      isEditLoadingRef.current = true;

      setPhoneNumberCountry(countryCode);
      prevCountryRef.current = countryCode;
      setResetCounter((prev) => prev + 1);

      setFormdata((prev) => ({
        ...prev,
        LGCVM_VehicleNumber: vehicle.LGCVM_VehicleNumber,
        LGCVM_VehicleName: vehicle.LGCVM_VehicleName,
        LGCVM_Dimension: vehicle.LGCVM_Dimension || "",
        LGCVM_DriverName: vehicle.LGCVM_DriverName || "",
        LGCVM_DriverNumber: formattedDriverNumber,
      }));

      // Reset flag after component fully updates
      setTimeout(() => {
        isEditLoadingRef.current = false;
      }, 300);

      // toast.info(`Editing Vehicle: ${vehicle.LGCVM_VehicleNumber}`);
    } catch (error) {
      console.error("Error checking vehicle status:", error);
      if (!toast.isActive("vehicle-status-error")) {
        toast.error("Failed to check vehicle status. Please try again.", {
          toastId: "vehicle-status-error",
        });
      }
    }
  };

  const handleSaveEdit = () => {
    // Clear the asterisk flag when user attempts to save edit
    setShowUpdateAsterisk(false);

    // Set update attempted flag to show asterisks for empty fields
    setUpdateAttempted(true);

    // Reset touched state so asterisks can appear for empty fields
    setTouched({
      LGCVM_VehicleName: false,
      LGCVM_VehicleNumber: false,
    });

    // Check for empty required fields - just return without adding error messages
    if (!formdata.LGCVM_VehicleNumber || !formdata.LGCVM_VehicleName) {
      return;
    }

    // Run validation explicitly for driver number to catch incomplete numbers
    const driverNumberError = validateField(
      "LGCVM_DriverNumber",
      formdata.LGCVM_DriverNumber,
    );
    if (driverNumberError) {
      setValidationError((prev) => ({
        ...prev,
        LGCVM_DriverNumber: driverNumberError,
      }));
    }

    // Validate all fields including driver number
    if (
      validationError.LGCVM_VehicleName ||
      validationError.LGCVM_VehicleNumber ||
      validationError.LGCVM_Dimension ||
      validationError.LGCVM_DriverName ||
      validationError.LGCVM_DriverNumber ||
      driverNumberError
    ) {
      return;
    }

    // Check for duplicate vehicle number (excluding current editing vehicle)
    const isDuplicate = vehicleDetails.some(
      (v, idx) =>
        idx !== editingIndex &&
        v.LGCVM_VehicleNumber === formdata.LGCVM_VehicleNumber,
    );

    if (isDuplicate) {
      if (!toast.isActive("edit-vehicle-duplicate")) {
        setIsToastActive(true);
        toast.error(
          `Vehicle Number: ${formdata.LGCVM_VehicleNumber} already exists.`,
          {
            toastId: "edit-vehicle-duplicate",
            onOpen: () => setIsToastActive(true),
            onClose: () => setIsToastActive(false),
          },
        );
      }
      return;
    }

    // Check if driver number contains only country code (no local digits)
    let finalDriverNumber = formdata.LGCVM_DriverNumber || null;
    if (finalDriverNumber) {
      const cleanedNumber = finalDriverNumber.replace(/\D/g, "");
      // Check if it's only a country code (no additional digits)
      const isOnlyCountryCode = Object.keys(phoneLengthMapping).some(
        (code) => cleanedNumber === code,
      );
      if (isOnlyCountryCode) {
        finalDriverNumber = null;
      }
    }

    // Update vehicle details
    const updatedVehicleDetails = [...vehicleDetails];
    updatedVehicleDetails[editingIndex] = {
      ...updatedVehicleDetails[editingIndex],
      LGCVM_VehicleNumber: formdata.LGCVM_VehicleNumber,
      LGCVM_VehicleName: formdata.LGCVM_VehicleName,
      LGCVM_Dimension: formdata.LGCVM_Dimension || null,
      LGCVM_DriverName: formdata.LGCVM_DriverName || null,
      LGCVM_DriverNumber: finalDriverNumber,
      isEdited: !updatedVehicleDetails[editingIndex].isNew, // Mark as edited if not new
    };

    setVehicleDetails(updatedVehicleDetails);

    // Reset edit state
    setIsEditing(false);
    setEditingIndex(null);
    setOriginalEditData(null);

    // Clear form fields
    setFormdata((prev) => ({
      ...prev,
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    }));

    // Clear validation errors
    setValidationError({
      LGCM_Name: "",
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    });

    // Reset phone number state
    setPhoneNumberCountry("91");
    prevCountryRef.current = "91";
    setResetCounter((prev) => prev + 1);

    // Reset touched state
    setTouched({
      LGCVM_VehicleName: false,
      LGCVM_VehicleNumber: false,
    });

    // Reset update attempted flag
    setUpdateAttempted(false);

    if (!toast.isActive("vehicle-updated")) {
      setIsToastActive(true);
      toast.success(`Vehicle : ${formdata.LGCVM_VehicleName} updated successfully.`, {
        toastId: "vehicle-updated",
        onOpen: () => setIsToastActive(true),
        onClose: () => setIsToastActive(false),
      });
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditingIndex(null);
    setOriginalEditData(null);

    // Clear form fields
    setFormdata((prev) => ({
      ...prev,
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    }));

    // Clear validation errors
    setValidationError({
      LGCM_Name: "",
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    });

    // Reset phone number state
    setPhoneNumberCountry("91");
    prevCountryRef.current = "91";
    setResetCounter((prev) => prev + 1);

    // Reset touched state
    setTouched({
      LGCVM_VehicleName: false,
      LGCVM_VehicleNumber: false,
    });

    // Reset update attempted flag
    setUpdateAttempted(false);

    // toast.info("Edit cancelled.");
  };

  const handleRemoveVehicleNumber = (index) => {
    const updatedVehicleDetails = [...vehicleDetails];
    updatedVehicleDetails.splice(index, 1);
    setVehicleDetails(updatedVehicleDetails);

    const updatedVehicleNumbers = [...vehicleNumbers];
    updatedVehicleNumbers.splice(index, 1);
    setVehicleNumbers(updatedVehicleNumbers); // Update the vehicleNumbers state

    // Update the LGCVM_VehicleNumbers field in formdata
    const updatedFormData = { ...formdata };
    updatedFormData.LGCVM_VehicleNumbers = updatedVehicleNumbers;
    setFormdata(updatedFormData);
    if (!toast.isActive("vehicle-deleted")) {
      setIsToastActive(true);
      toast.success(
        `Vehicle : ${vehicleDetails[deleteIndex]?.LGCVM_VehicleNumber} removed successfully.`,
        {
          toastId: "vehicle-deleted",
          onOpen: () => setIsToastActive(true),
          onClose: () => setIsToastActive(false),
        },
      );
    }
    handleCloseModal(); // Close modal after action
  };

  const handleConfirmation = async () => {
    try {
      // Call the API to get the count for the selected vehicle
      const response = await fetch(
        `${config.API_URL}/logistic_company_master/vehiclestatus/${vehicleDetails[suspendIndex]?.LGCVM_ID}`,
      );
      const data = await response.json();
      console.log("DATA:", data);
      console.log("COUNT", data.count);

      // If count is greater than 0, show an error toast and prevent suspension
      if (data.count > 0) {
        if (!toast.isActive("vehicle-suspend-blocked")) {
          setIsToastActive(true);
          toast.error(
            `Vehicle : ${vehicleDetails[suspendIndex]?.LGCVM_VehicleNumber} cannot be Suspend because it has active shipments.`,
            {
              toastId: "vehicle-suspend-blocked",
              onOpen: () => setIsToastActive(true),
              onClose: () => setIsToastActive(false),
            },
          );
        }
        setShowConfirmation(false);
        setSuspendIndex(null);
        return;
      }

      // Proceed with suspending the vehicle
      const newVehicleDetails = [...vehicleDetails];
      newVehicleDetails[suspendIndex].LGCVM_Status = 3;
      setVehicleDetails(newVehicleDetails);
      setSuspendIndex(null);
      setShowConfirmation(false);

      if (!toast.isActive("vehicle-suspended")) {
        setIsToastActive(true);
        toast.success(
          `Vehicle : ${vehicleDetails[suspendIndex]?.LGCVM_VehicleNumber} suspended successfully.`,
          {
            toastId: "vehicle-suspended",
            onOpen: () => setIsToastActive(true),
            onClose: () => setIsToastActive(false),
          },
        );
      }
    } catch (error) {
      console.error("Error suspending vehicle:", error);
      if (!toast.isActive("vehicle-suspend-error")) {
        setIsToastActive(true);
        toast.error("Failed to check vehicle status.", {
          toastId: "vehicle-suspend-error",
          onOpen: () => setIsToastActive(true),
          onClose: () => setIsToastActive(false),
        });
      }
      setShowConfirmation(false);
      setSuspendIndex(null);
    }
  };

  const handleCancel = () => {
    // Dismiss all toasts
    toast.dismiss();
    setIsToastActive(false);

    // Reset all form input fields including status
    setFormdata((prev) => ({
      ...prev,
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
      LGCM_Status: 1, // Reset status to Active
    }));

    // Reset validation errors
    setValidationError({
      LGCM_Name: "",
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    });

    // Reset add click state
    setAddClicked(false);

    // Reset edit mode
    setIsEditing(false);
    setEditingIndex(null);
    setOriginalEditData(null);

    // Reset update attempted flag
    setUpdateAttempted(false);

    // Reset touched state
    setTouched({
      LGCVM_VehicleName: false,
      LGCVM_VehicleNumber: false,
    });

    // Reset phone number state
    setPhoneNumberCountry("91");
    prevCountryRef.current = "91";
    setResetCounter((prev) => prev + 1);

    // Reset other states
    setFormSubmitted(false);
    setMessage("");
    setShowUpdateAsterisk(false);
  };

  const handleCancelConfirmation = () => {
    setSuspendIndex(null);
    setShowConfirmation(false); // Hide the confirmation popup
  };

  const handleSuspend = (index) => {
    setShowConfirmation(true);
    setSuspendIndex(index);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isProcessingRef.current) {
      return;
    }

    // Check if user is in edit mode and show asterisk on UPDATE button
    if (isEditing) {
      setShowUpdateAsterisk(true);
      isProcessingRef.current = false;
      return;
    }

    isProcessingRef.current = true;
    setFormSubmitted(true);
    setAddClicked(false); // Clear addClicked to prevent asterisks from showing
    setIsEditing(false); // Clear isEditing to prevent asterisks from showing
    setEditingIndex(null); // Clear editing index
    setShowUpdateAsterisk(false); // Clear asterisk flag
    setLoading(true);

    try {
      // Check if all vehicles are Suspend
      const allSuspend = vehicleDetails.every(
        (vehicleDetail) => vehicleDetail.LGCVM_Status === 3,
      );

      if (allSuspend) {
        if (!toast.isActive("all-suspended")) {
          setIsToastActive(true);
          toast.error(
            "At least one vehicle is required to save the logistic party.",
            {
              toastId: "all-suspended",
              onOpen: () => setIsToastActive(true),
              onClose: () => setIsToastActive(false),
            },
          );
        }
        setLoading(false);
        isProcessingRef.current = false;
        return;
      }

      if (formdata.LGCM_Status === 2) {
        const checkRes = await fetch(
          `${config.API_URL}/logistic_company_master/logistic_party_can_inactivate`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ LGCM_ID }),
          },
        );

        const checkData = await checkRes.json();

        if (!checkRes.ok) {
          if (!toast.isActive("validate-inactivate-error")) {
            setIsToastActive(true);
            toast.error("Failed to validate inactivation. Please try again.", {
              toastId: "validate-inactivate-error",
              onOpen: () => setIsToastActive(true),
              onClose: () => setIsToastActive(false),
            });
          }
          setLoading(false);
          isProcessingRef.current = false;
          return;
        }

        if (!checkData.canInactivate) {
          if (!toast.isActive("cannot-inactivate")) {
            setIsToastActive(true);
            toast.error(
              `You cannot inactivate the Logistic Party : ${formdata.LGCM_Name} ` +
              `because ${checkData.shipmentCount} active vehicles linked to this logistic company. `,
              {
                toastId: "cannot-inactivate",
                onOpen: () => setIsToastActive(true),
                onClose: () => setIsToastActive(false),
              },
            );
          }
          setLoading(false);
          isProcessingRef.current = false;
          return;
        }
      }

      const requestData = {
        LGCM_Name: formdata.LGCM_Name,
        LGCM_Status: formdata.LGCM_Status,

        LGCVM_VehicleNumbers: vehicleDetails.map((vehicleDetail) => ({
          vehicleNumber: vehicleDetail.LGCVM_VehicleNumber,
          vehicleName: vehicleDetail.LGCVM_VehicleName,
          dimension: vehicleDetail.LGCVM_Dimension || null,
          driverName: vehicleDetail.LGCVM_DriverName || null,
          driverNumber: vehicleDetail.LGCVM_DriverNumber || null,
          LGCVM_Status: vehicleDetail.LGCVM_Status,
          LGCVM_SCPID: selectedScpId,
        })),

        LGCM_ModifiedBy: UM_UserId,
      };

      console.log("requestData", requestData);

      const transactionDetails = [
        {
          AUTRN_OldValue: "-",
          AUTRN_NewValue: formdata.LGCM_Name,
          AUTRN_ParamererName: "Logistic Party Name",
        },
        ...vehicleDetails.map(
          ({ LGCVM_VehicleNumber, previousLGCVM_VehicleNumber }) => ({
            AUTRN_OldValue: previousLGCVM_VehicleNumber || "-", // Old vehicle number (previous)
            AUTRN_NewValue: LGCVM_VehicleNumber, // New vehicle number
            AUTRN_ParamererName: "Vehicle Number",
          }),
        ),
        {
          AUTRN_OldValue: "-",
          AUTRN_NewValue: formdata.LGCM_Status,
          AUTRN_ParamererName: "Status",
        },
      ];

      // Update logistic company data
      const logisticCompanyResponse = await fetch(
        `${config.API_URL}/logistic_company_master/update/${LGCM_ID}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        },
      );

      if (!logisticCompanyResponse.ok) {
        const errorData = await logisticCompanyResponse.json();

        // Check if error is due to active shipments
        if (errorData.shipmentCount && errorData.shipmentCount > 0) {
          if (!toast.isActive("shipment-linked-error")) {
            setIsToastActive(true);
            toast.error(
              errorData.message ||
              `Cannot inactivate the Logistic Party : ${formdata.LGCM_Name} because ${errorData.shipmentCount} active shipment(s) with In Transit or Approved status are linked to this party.`,
              {
                toastId: "shipment-linked-error",
                onOpen: () => setIsToastActive(true),
                onClose: () => setIsToastActive(false),
              },
            );
          }
          logAction(
            `Cannot inactivate Logistic Party: ${formdata.LGCM_Name} - Active shipments exist`,
          );
        } else {
          if (!toast.isActive("update-error")) {
            setIsToastActive(true);
            toast.error(
              errorData.message || "Error updating logistic company data",
              {
                toastId: "update-error",
                onOpen: () => setIsToastActive(true),
                onClose: () => setIsToastActive(false),
              },
            );
          }
          logAction(
            `Error updating Logistic Party Name: ${formdata.LGCM_Name}`,
          );
        }
        setLoading(false);
        isProcessingRef.current = false;
        return;
      }

      const responseData = await logisticCompanyResponse.json();
      setMessage(responseData.message);
      logAction(
        `Logistic Party Name: ${formdata.LGCM_Name} updated successfully`,
      );

      isProcessingRef.current = false;
      if (!toast.isActive("update-success")) {
        setIsToastActive(true);
        toast.success(
          `Logistic Party : ${formdata.LGCM_Name} updated successfully.`,
          {
            toastId: "update-success",
            onOpen: () => setIsToastActive(true),
            onClose: () => {
              setIsToastActive(false);
              navigate(`/dashboard/lgcm`);
              setLoading(false);
            },
          },
        );
      }

      logAudit(
        "Logistic Party Master",
        `Logistic Party Name : ${formdata.LGCM_Name} updated successfully in database`,
        "-",
        `${formdata.LGCM_Name}`,
        false,
        transactionDetails,
      );
    } catch (error) {
      console.error("Error:", error);
      setMessage("An error occurred while updating data.");
      if (!toast.isActive("general-error")) {
        setIsToastActive(true);
        toast.error("An error occurred while updating data.", {
          toastId: "general-error",
          onOpen: () => setIsToastActive(true),
          onClose: () => setIsToastActive(false),
        });
      }
      logAction(
        `An error in updating data Logistic Party Name: ${formdata.LGCM_Name} updated successfully`,
      );
      setLoading(false);
      isProcessingRef.current = false;
    }
  };

  const handleShowModal = (index) => {
    setDeleteIndex(index);
    setShowModal(true);
  };

  return (
    <React.Fragment>
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
        limit={1}
        newestOnTop={true}
      />

      {loading && (
        <div
          style={{
            position: "fixed", // Sit on top of the page content
            left: 0,
            top: 0,
            width: "100%", // Full width
            height: "100%", // Full height

            zIndex: 1000, // Sit on top of the other elements
          }}
        />
      )}

      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="main_container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="formHeading">Logistic Party Master</h2>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Logistic Party Name
                      {formSubmitted && !formdata.LGCM_Name && " *"}
                    </label>
                    <input
                      type="text"
                      name="LGCM_Name"
                      className={`form-input ${validationError.LGCM_Name ? "is-invalid" : ""}`}
                      placeholder=""
                      value={formdata.LGCM_Name}
                      onChange={handleInput}
                      onBlur={handleBlur}
                      disabled
                    />
                    {validationError.LGCM_Name && (
                      <div
                        className="invalid-feedback"
                        style={{ fontSize: "16px" }}
                      >
                        {validationError.LGCM_Name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Vehicle Name
                    {(addClicked || isEditing || updateAttempted) &&
                      !formdata.LGCVM_VehicleName &&
                      !touched.LGCVM_VehicleName && (
                        <span className="text-danger"> *</span>
                      )}
                  </label>
                  <input
                    type="text"
                    name="LGCVM_VehicleName"
                    className={`form-input ${validationError.LGCVM_VehicleName ? "is-invalid" : ""}`}
                    value={formdata.LGCVM_VehicleName}
                    onChange={handleInput}
                    onBlur={handleBlur}
                    autoComplete="off"
                    disabled={isToastActive}
                  />
                  {validationError.LGCVM_VehicleName && (
                    <div
                      className="invalid-feedback"
                      style={{ fontSize: "16px" }}
                    >
                      {validationError.LGCVM_VehicleName}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Vehicle Number
                      {(addClicked || isEditing || updateAttempted) &&
                        !formdata.LGCVM_VehicleNumber &&
                        !touched.LGCVM_VehicleNumber && (
                          <span className="text-danger"> *</span>
                        )}
                    </label>
                    <input
                      type="text"
                      name="LGCVM_VehicleNumber"
                      className={`form-input ${validationError.LGCVM_VehicleNumber ? "is-invalid" : ""}`}
                      value={formdata.LGCVM_VehicleNumber}
                      onChange={handleInput}
                      onBlur={handleBlur}
                      autoComplete="off"
                      disabled={isToastActive}
                    />

                    {validationError.LGCVM_VehicleNumber && (
                      <div
                        className="invalid-feedback"
                        style={{ fontSize: "16px" }}
                      >
                        {validationError.LGCVM_VehicleNumber}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Vehicle Volume</label>
                  <input
                    type="text"
                    name="LGCVM_Dimension"
                    className={`form-input ${validationError.LGCVM_Dimension ? "is-invalid" : ""}`}
                    value={formdata.LGCVM_Dimension}
                    onChange={handleInput}
                    onBlur={handleBlur}
                    autoComplete="off"
                    disabled={isToastActive}
                  />
                  {validationError.LGCVM_Dimension && (
                    <div
                      className="invalid-feedback"
                      style={{ fontSize: "16px" }}
                    >
                      {validationError.LGCVM_Dimension}
                    </div>
                  )}
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Driver Name</label>
                  <input
                    type="text"
                    name="LGCVM_DriverName"
                    className={`form-input ${validationError.LGCVM_DriverName ? "is-invalid" : ""}`}
                    value={formdata.LGCVM_DriverName}
                    onChange={handleInput}
                    onBlur={handleBlur}
                    autoComplete="off"
                    disabled={isToastActive}
                  />
                  {validationError.LGCVM_DriverName && (
                    <div
                      className="invalid-feedback"
                      style={{ fontSize: "16px" }}
                    >
                      {validationError.LGCVM_DriverName}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">Driver Phone Number</label>
                  <div
                    className={
                      validationError.LGCVM_DriverNumber
                        ? "phone-input-error"
                        : ""
                    }
                  >
                    <PhoneInput
                      className="phone-input-custom"
                      dropdownClass="phone-dropdown-scroll"
                      key={phoneNumberCountry + "-" + resetCounter}
                      country={
                        phoneNumberToCountryCode(phoneNumberCountry) || "in"
                      }
                      value={formdata.LGCVM_DriverNumber}
                      onChange={(value, countryData) =>
                        handleInput(value, countryData)
                      }
                      onCountryChange={(country) => {
                        // Skip if we're loading edit data
                        if (isEditLoadingRef.current) {
                          return;
                        }

                        const newDialCode = country.dialCode;
                        setPhoneNumberCountry(newDialCode);
                        setFormdata((prev) => ({
                          ...prev,
                          LGCVM_DriverNumber: newDialCode,
                        }));
                        prevCountryRef.current = newDialCode;
                        setValidationError((prev) => ({
                          ...prev,
                          LGCVM_DriverNumber: "",
                        }));
                      }}
                      inputClass={`form-input ${validationError.LGCVM_DriverNumber ? "is-invalid" : ""}`}
                      countryCodeEditable={false}
                      onlyCountries={allowedCountries}
                      enableSearch={false}
                      autoFormat={true}
                      autoComplete="off"
                      disabled={isToastActive}
                    />
                  </div>
                  {validationError.LGCVM_DriverNumber && (
                    <div
                      className="invalid-feedback"
                      style={{ fontSize: "16px", display: "block" }}
                    >
                      {validationError.LGCVM_DriverNumber}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <div className="select-container">
                      <StatusCustomDropdown
                        name="LGCM_Status"
                        options={[
                          { value: 1, label: "Active" },
                          { value: 2, label: "Inactive" },
                        ]}
                        value={formdata.LGCM_Status || 1} // Assuming '1' is the value for Active
                        onChange={handleInput}
                        idKey="value"
                        displayKey="label"
                        disabled={isToastActive}
                      />
                      {/* <div className='icon-container'>
                    <i>
                      <ion-icon name="caret-down-outline"></ion-icon>
                    </i>
                  </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className="mb-3"
                    style={{ display: "flex", gap: "10px" }}
                  >
                    {isEditing ? (
                      <>
                        <button
                          type="button"
                          className="lgcm_add_btn"
                          onClick={handleSaveEdit}
                          disabled={isToastActive}
                        >
                          UPDATE
                        </button>
                        {showUpdateAsterisk && (
                          <span
                            className="text-danger"
                            style={{
                              fontSize: "20px",
                              marginTop: "10px",
                              marginRight: "10px",
                            }}
                          >
                            *
                          </span>
                        )}
                      </>
                    ) : (
                      <button
                        type="button"
                        className="lgcm_add_btn"
                        onClick={handleAddVehicleNumber}
                        disabled={isToastActive}
                      >
                        ADD
                      </button>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <table className="tableClass">
                    <thead>
                      <tr>
                        <th scope="col">Sr. No.</th>
                        <th>Vehicle Name</th>
                        <th>Vehicle Number</th>
                        <th>Vehicle Volume</th>
                        <th>Driver Name</th>
                        <th>Driver Phone Number</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vehicleDetails &&
                        vehicleDetails.map((vehicleDetail, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{vehicleDetail.LGCVM_VehicleName}</td>
                            <td>{vehicleDetail.LGCVM_VehicleNumber}</td>
                            <td>{vehicleDetail.LGCVM_Dimension || "-"}</td>
                            <td>{vehicleDetail.LGCVM_DriverName || "-"}</td>
                            <td>
                              {formatPhoneNumberDisplay(
                                vehicleDetail.LGCVM_DriverNumber,
                              )}
                            </td>

                            <td>
                              {vehicleDetail.Suspend ? (
                                <span>N/A</span>
                              ) : (
                                <React.Fragment>
                                  <div
                                    className="icon_container"
                                    style={{
                                      gap: 6,
                                      justifyContent: "center",
                                      display: "flex",
                                    }}
                                  >
                                    {vehicleDetail.isNew &&
                                      vehicleDetail.isNew === true ? (
                                      <React.Fragment>
                                        <img
                                          title="Edit"
                                          src={Icon3}
                                          alt="edit"
                                          style={{
                                            width: "12px",
                                            height: "12px",
                                            marginRight: 6,
                                            cursor: "pointer",
                                            opacity: isToastActive ? 0.5 : 1,
                                          }}
                                          className="editicon"
                                          onClick={() =>
                                            !isToastActive && handleEdit(index)
                                          }
                                        />

                                        <img
                                          title="Remove"
                                          src={Icon5}
                                          alt="trash"
                                          style={{
                                            height: "12px",
                                            width: "12px",
                                            cursor: "pointer",
                                            opacity: isToastActive ? 0.5 : 1,
                                          }}
                                          className="action_icon"
                                          onClick={() =>
                                            !isToastActive &&
                                            handleShowModal(index)
                                          } // Open modal on click
                                        />
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment>
                                        {vehicleDetail.LGCVM_Status === 1 ||
                                          vehicleDetail.LGCVM_Status === 2 ? (
                                          <React.Fragment>
                                            <img
                                              title="Edit"
                                              src={Icon3}
                                              alt="edit"
                                              className="editicon"
                                              style={{
                                                width: "12px",
                                                height: "12px",
                                                marginRight: 6,
                                                cursor: "pointer",
                                                opacity: isToastActive
                                                  ? 0.5
                                                  : 1,
                                              }}
                                              onClick={() =>
                                                !isToastActive &&
                                                handleEdit(index)
                                              }
                                            />
                                            <img
                                              title="Suspend"
                                              src={Icon4}
                                              alt="suspend"
                                              className=""
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                marginRight: 6,
                                                cursor: "pointer",
                                                opacity: isToastActive
                                                  ? 0.5
                                                  : 1,
                                              }}
                                              onClick={() =>
                                                !isToastActive &&
                                                handleSuspend(
                                                  index,
                                                  vehicleDetail.LGCVM_ID,
                                                )
                                              }
                                            />
                                          </React.Fragment>
                                        ) : vehicleDetail.LGCVM_Status === 3 ? (
                                          <span>N/A</span>
                                        ) : null}
                                      </React.Fragment>
                                    )}
                                  </div>
                                </React.Fragment>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="button-container">
          <button
            type="submit"
            className="save_btn"
            disabled={isToastActive || showModal || showConfirmation || loading}
          >
            SAVE
          </button>
          <button
            type="reset"
            className="reset_btn"
            onClick={handleCancel}
            disabled={isToastActive}
          >
            RESET
          </button>
          <Link
            to={isToastActive ? "#" : `/lgcmlist`}
            className="list_btn"
            type="button"
            style={{
              pointerEvents: isToastActive ? "none" : "auto",
            }}
          >
            LIST
          </Link>
        </div>
      </form>

      {showConfirmation && (
        <ConfirmationPopup
          title="Confirmation"
          message={`Are you sure you want to suspend this Vehicle : ${vehicleDetails[suspendIndex]?.LGCVM_VehicleNumber} ?`}
          onConfirm={handleConfirmation}
          onCancel={handleCancelConfirmation}
          disabled={isToastActive}
        />
      )}

      {showModal && (
        <div className="popup_overlay">
          <div className="resetpopup">
            <h1>:: User Confirmation ::</h1>
            <h4>
              Are you sure you want to remove this Vehicle : {" "}
              {vehicleDetails[deleteIndex]?.LGCVM_VehicleNumber} ?
            </h4>
            <div className="popup_btn_container">
              <button
                className="yes_btn"
                onClick={() => handleRemoveVehicleNumber(deleteIndex)}
                disabled={isToastActive}
              >
                Yes
              </button>
              <button className="no_btn" onClick={handleCloseModal} disabled={isToastActive}>
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {(loading || isToastActive) && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            zIndex: 1000,
          }}
        />
      )}
    </React.Fragment>
  );
}
export default LGCMEdit;
